/**
 * 格式化日期对象为字符串
 * @param {Date} date - 日期对象
 * @param {string} fmt - 格式模板，如 'yyyy-MM-dd HH:mm:ss'
 * @returns {string}
 */
export function formatDate(date, fmt = 'yyyy-MM-dd') {
    if (!date || !(date instanceof Date)) {
        return '';
    }

    const o = {
        'M+': date.getMonth() + 1,                 // 月份
        'd+': date.getDate(),                        // 日
        'H+': date.getHours(),                       // 小时
        'm+': date.getMinutes(),                     // 分
        's+': date.getSeconds(),                     // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds()                  // 毫秒
    };

    let result = fmt;

    // 处理年份 (y+)
    if (/(y+)/.test(result)) {
        result = result.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    // 处理其他部分
    for (const k in o) {
        if (new RegExp('(' + k + ')').test(result)) {
            result = result.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }

    return result;
}
